// Canonical number string: no trailing zeros, no trailing decimal point.
// Single source of truth shared by the bank builder, the answer display and
// the hint figures so they can never disagree.
export function formatNumber(n: number): string {
  if (Number.isInteger(n)) return String(n);
  return n.toFixed(10).replace(/\.?0+$/, '');
}
